import React, { useState } from 'react';
import { Handle, Position, NodeProps, useReactFlow } from '@xyflow/react';
import { StopCircle, X } from 'lucide-react';
import { StopNodeData } from '../types';

export function StopNode({ id, data: rawData, selected }: NodeProps) {
  const data = rawData as unknown as StopNodeData;
  const [isHovered, setIsHovered] = useState(false);
  const { setNodes, setEdges } = useReactFlow();

  const handleDelete = (e: React.MouseEvent) => {
    e.stopPropagation();
    setNodes((nodes) => nodes.filter((n) => n.id !== id));
    setEdges((edges) => edges.filter((e) => e.source !== id && e.target !== id));
  };

  return (
    <div
      className={`relative min-w-[160px] rounded-xl border-2 bg-white shadow-lg transition-all ${
        selected ? 'border-orange-500 shadow-orange-200' : 'border-orange-400'
      }`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Delete button on hover */}
      {isHovered && (
        <button
          onClick={handleDelete}
          className="absolute -top-2 -right-2 z-10 flex h-5 w-5 items-center justify-center rounded-full bg-red-500 text-white shadow-md hover:bg-red-600 transition-colors"
          title="Delete node"
        >
          <X size={12} />
        </button>
      )}
      <Handle type="target" position={Position.Top} className="!bg-orange-500 !w-3 !h-3" />
      <div className="flex items-center gap-2 rounded-t-xl bg-orange-500 px-3 py-2">
        <StopCircle size={14} className="text-white" />
        <span className="text-xs font-semibold uppercase tracking-wider text-white">Stop</span>
      </div>
      <div className="px-3 py-2">
        {data.reason ? (
          <>
            <p className="text-xs text-gray-500 dark:text-gray-400">Reason</p>
            <p className="text-sm font-medium text-gray-800 dark:text-gray-200">{data.reason}</p>
          </>
        ) : (
          <p className="text-sm text-gray-500 dark:text-gray-400 text-center">Stop workflow</p>
        )}
      </div>
      {/* No source handle - this is a terminal node */}
    </div>
  );
}
